import React from "react"
import { TwoPassRenderer } from "./utils/useTwoPass"

export default function wrapWithProvider({ element }) {
  return <TwoPassRenderer>{element}</TwoPassRenderer>
}
